const EMAIL_PATTERN = /^[a-zA-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

export { EMAIL_PATTERN };
